const stages = [
  {
    step: "01",
    icon: "ri-virus-line",
    title: "病毒传播",
    text: "源头物料被跨平台搬运，播放与转评进入指数上探。复制速度快于澄清速度，是第一道扩散闸门。",
    signal: "指数增长曲线",
  },
  {
    step: "02",
    icon: "ri-chat-3-line",
    title: "评论区沦陷",
    text: "前排热评被反噬与反转吞没，粉丝控评防线失守。舆论从站队走向摊牌，是话题从资讯升维的转折点。",
    signal: "讨论峰值 · 热评反转",
  },
  {
    step: "03",
    icon: "ri-fire-line",
    title: "热搜登顶",
    text: "全网检索与讨论量冲上主榜高位，媒体官号跟进定性式报道。榜首位置被锁定，话题完成公共化。",
    signal: "主榜榜首 · 官媒跟进",
  },
  {
    step: "04",
    icon: "ri-arrow-up-double-line",
    title: "转发刷屏",
    text: "衍生梗与表情包接力反哺热度，转发刷屏从资讯场景蔓延到泛娱乐圈层，生命周期被二次拉长。",
    signal: "衍生二创 · 全圈层扩散",
  },
];

export default function StageBreakdown() {
  return (
    <section className="mx-auto max-w-[1440px] px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-2xl">
        <div className="flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-red-600">
          <i className="ri-stack-line"></i> 引爆路径拆解
        </div>
        <h2 className="mt-3 font-serif text-2xl font-black tracking-tight text-stone-900 md:text-4xl">
          四道关卡，看懂一场热搜登顶
        </h2>
        <p className="mt-3 text-sm leading-7 text-stone-500">
          每条登上热搜的爆料，几乎都走完相同的扩散路径。我们把过程压成四道关卡，方便你快速判断话题处在引爆的哪一段。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {stages.map((s) => (
          <div
            key={s.step}
            className="group relative overflow-hidden rounded-lg border border-stone-200 bg-white p-5 transition-colors hover:border-red-200"
          >
            <div className="absolute right-4 top-4 font-serif text-4xl font-black text-stone-100 transition-colors group-hover:text-red-100">
              {s.step}
            </div>
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-stone-900 text-xl text-white">
              <i className={s.icon}></i>
            </span>
            <h3 className="mt-4 text-lg font-bold text-stone-900">{s.title}</h3>
            <p className="mt-2 text-sm leading-6 text-stone-500">{s.text}</p>
            <div className="mt-4 inline-flex items-center gap-1.5 rounded bg-stone-100 px-2 py-1 text-[11px] font-semibold text-stone-500">
              <i className="ri-signal-tower-line text-red-600"></i> 信号：{s.signal}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}